import { Stack, Typography } from '@mui/material'
import { Checkbox, TextField } from '@ui/forms'
import { useElementLabel } from '@editorHooks'

interface Props {
  elementGuid?: string
  showBeginOnNewPage: boolean
}

const BaseFormFields = ({ elementGuid, showBeginOnNewPage }: Props) => {
  const getLabel = useElementLabel()

  return (
    <Stack direction="column" spacing={2}>
      <TextField name="name" label="Name" placeholder="Name des Abschnitts" />

      {elementGuid && (
        <TextField name="element" label="Element" value={getLabel(elementGuid)} disabled />
      )}

      {showBeginOnNewPage && (
        <Stack direction="row" spacing={0} display="flex" alignItems="center">
          <Checkbox name="begin_on_new_page" />
          <Typography>Auf neuer Seite beginnen</Typography>
        </Stack>
      )}
    </Stack>
  )
}

export default BaseFormFields
